var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index_vue"},[_c('Row',{directives:[{name:"show",rawName:"v-show",value:(_vm.wxState),expression:"wxState"}]},[_c('topP')],1),_vm._v(" "),(_vm.wxState)?_c('div',{staticClass:"flowIndex_leftNav"},[_c('leftNav')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"flowIndex_right",attrs:{"id":"zhuRight"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ad06a58","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index.vue
// module id = null
// module chunks = 